import cn from 'classnames';
import styles from './Title.module.scss';
import { TitleVariant } from '@/types';

export enum TitleFont {
  Segoe = 'segoe',
  Inter = 'inter',
}

type TitleProps = {
  className?: string;
  text: string;
  variant?: TitleVariant;
  heading?: boolean;
  bold?: boolean;
  font?: TitleFont;
};

export function Title({
  className,
  text,
  variant = TitleVariant.Primary,
  heading,
  font = TitleFont.Segoe,
  bold,
}: TitleProps) {
  const wrapperClassName = cn(
    styles.wrapper,
    {
      [styles.secondary]: variant === TitleVariant.Secondary,
      [styles.inter]: font === TitleFont.Inter,
      [styles.bold]: bold,
    },
    className,
  );

  if (heading) return <h1 className={wrapperClassName}>{text}</h1>;

  return <div className={wrapperClassName}>{text}</div>;
}
